import React, { useState } from 'react';
import logo from '../../../@assets/logo.svg';
import { CgNotes } from 'react-icons/cg';
import { NavLink } from 'react-router-dom';
import { FaRegUserCircle, FaRocketchat } from "react-icons/fa";
import { RiExchangeDollarLine } from "react-icons/ri";
import { GrTransaction } from "react-icons/gr";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdLogOut } from "react-icons/io";
import { useDispatch } from 'react-redux';
import { logout } from '../../../@redux/Action/Config';

function Sidebar() {
    const [open, setOpen] = useState(true);
    const dispatch = useDispatch();

    const handleLogout = async () => {
        await dispatch(logout());
    };

    const Menus = [
        { title: "Dashboard", to: "/dashboard", Icon: CgNotes },
        { title: "Profile", to: "/profile", Icon: FaRegUserCircle },
        { title: "Beneficiary", to: "/beneficiary", Icon: FaRocketchat },
        { title: "Remitters", to: "/remitter", Icon: RiExchangeDollarLine },
        { title: "Transactions", to: "/transaction", Icon: GrTransaction },
        { title: "Settings", to: "/setting", Icon: IoSettingsOutline },
    ];

    return (
        <div className='col-12 col-md-3 px-3 px-md-3 py-2 py-md-0 shadow-sm border background-color'>
            <div className='pb-3 pt-4'>
                <img src={logo} alt='logo' width={250} />
            </div>
            <ul className="nav nav-pills flex-column mb-auto">
                {Menus.map(item => {
                    const { Icon, title, to } = item;
                    return (
                        <li className="nav-item sidebar-nav my-2" key={title}>
                            <NavLink 
                                to={to} 
                                className={({ isActive }) => 
                                    `nav-link text-success ${isActive ? "active" : ""}`
                                }
                            >
                                <Icon size={22} /> {title}
                            </NavLink>
                        </li>
                    );
                })}
                <li className="nav-item sidebar-nav my-1">
                    <button 
                        onClick={handleLogout}
                        className="nav-link text-success border-0 bg-transparent"
                        style={{width: '100%', textAlign: 'left'}}
                    >
                        <IoMdLogOut size={22} /> Logout
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default Sidebar;
